import is from '../objects/is';
import { allow } from './allow';

/*
   a wrapper for localStorage() that will store every key value in a serialized JSON string
   this allows localStorage to hold string, booleans, numbers, nulls, objects, and arrays
   if localStorage() is not available, it will use a standard object for storage
 */
let temp: any = {};
export default class local {
   static clear = () => {
       if (local.localStorageIsSupported())
           localStorage.clear();
       // noinspection JSUndeclaredVariable
       temp = {};
   };

   static getItem = (itemName = '', defaultValue: any = '__noDefaultValueSupplied__') => {
       allow.aString(itemName, is.not.empty);
       if (local.localStorageIsSupported()) {
           const valueObject = JSON.parse(localStorage.getItem(itemName) || 'null');
           if (valueObject === null) {
               if (defaultValue !== '__noDefaultValueSupplied__') {
                   local.setItem(itemName, defaultValue);
                   return defaultValue;
               }
               return null;
           }
           if (Object.prototype.hasOwnProperty.call(valueObject, 'value')) {
               if (valueObject.value === null && defaultValue !== '__noDefaultValueSupplied__') {
                   local.setItem(itemName, defaultValue);
                   return defaultValue;
               }
               return valueObject.value;
           }
           return null;
       } else {
           if (Object.prototype.hasOwnProperty.call(temp, itemName))
               return temp[itemName];
           else if (defaultValue !== '__noDefaultValueSupplied__') {
               temp[itemName] = defaultValue;
               return defaultValue;
           }
           return null;
       }
   };

   static localStorageIsSupported = () => {
       try {
           const testKey = '__some_random_key_you_are_not_going_to_use__';
           localStorage.setItem(testKey, testKey);
           localStorage.removeItem(testKey);
           return true;
       } catch (error) {
           return false;
       }
   };

   static removeItem = (itemName = '') => {
       allow.aString(itemName, is.not.empty);
       if (local.localStorageIsSupported())
           localStorage.removeItem(itemName);
       else if (Object.prototype.hasOwnProperty.call(temp, itemName))
           delete temp[itemName];
       return true;
   };

   static setItem = (itemName = '', itemValue: any) => {
       allow.aString(itemName, is.not.empty);
       if (local.localStorageIsSupported()) {
           const valueToBeSerialized = {value : itemValue};
           const serializedValue = JSON.stringify(valueToBeSerialized);
           localStorage.setItem(itemName, serializedValue);
       } else {
           temp[itemName] = itemValue;
       }
       return itemValue;
   };
}